





















































import { computed, defineComponent, getCurrentInstance } from '@vue/composition-api';
import LinkShareDialog from '@/renderer/components/dialog/linkShare/components/linkShareDialog.vue';
import i18n, { i18n_t } from '@/locales/i18n';
import shareInWeMeetingHandler from '@/renderer/views/desktop/headbar/composition/shareInWeMeetingHandler';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
import { isAllowPreviewImage } from '@/renderer/scripts/composition/allowPreview';
import tips from '@/renderer/scripts/utils/tips';
export default defineComponent({
  components: {
    LinkShareDialog,
  },
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
    linkData: {
      required: false,
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const comProps = computed(() => {
      const propsConfig: Record<string, any> = {};
      if (vm.$store.getters.isMobileStyle) {
        propsConfig.placement = 'bottom';
        propsConfig.mode = 'overlay';
        propsConfig.size = '500px';
        propsConfig.closeBtn = true;
      } else {
        propsConfig.mode = 'modal';
        propsConfig.top = '6%';
        propsConfig.width = '700';
        propsConfig.attach = 'body';
        propsConfig.confirmBtn = null;
        propsConfig.cancelBtn = null;
      }
    });
    const fileItem = computed(() => props.linkData.item);
    const showEdit = computed(() => fileItem.value?.canEdit || false);
    const showPreview = computed(() => fileItem.value?.canPreview || false);
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const isMultiFile = computed(() => props.linkData?.type === 'multi-file');
    const { methods: wemeetingMethods } = shareInWeMeetingHandler();
    const methods = {
      close() {
        innerShow.value = false;
      },
      shareInWemeet(action: 'preview' | 'edit' | string) {
        const { name, size, path, previewByDoc, spaceOrgId } = fileItem.value;
        const { directoryInfoList } = props.linkData;
        if (action === 'preview') {
          if (isAllowPreviewImage(name) && size >= ConstantConfig.ciImageMaxSize) {
            // 万象最大支持32mb
            tips.error(i18n_t('文件过大，请下载至本地查看'));
            return;
          }
        }
        const shareParams = {
          name,
          path,
          spaceId: directoryInfoList[0].spaceId,
          previewByDoc,
          spaceOrgId,
          btnLocation: 'share_dialog',
        };
        wemeetingMethods.share(action, shareParams);
        methods.close();
      },
    };
    return {
      innerShow,
      isMultiFile,
      comProps,
      fileItem,
      showEdit,
      showPreview,
      ...methods,
    };
  },
});
